<template>
    <form-client :request-id="requestId" :initial-step="initialStep" />
</template>
<script>
    import FormClient from '../../components/formClientRequest'
/** Componente padre para el componente 'FormClient' usado para procesar la solictud con los datos actualizados por las empresas. */
    export default {
        name: 'FormMassiveRequest',
        title: 'Procesar Solicitud de Envío Masivo | Infoguia',
        props: {
            /** prop para el id del request perteneciente al formulario */
            requestId: {
                required: true,
            },
            /** prop para indicar en que paso debe iniciar el formulario, por defecto es 0 para que inicie en el paso 1 */
            initialStep: {
                type: String,
                default: function () {
                    return '0'
                }
            },
        },
        components: {
            FormClient,
        },
        data() {
            return {}
        },
        beforeCreate: function () {},
        created() {},
        methods: {},
        computed: {},
        watch: {}
    }
</script>